import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        active:
          "border-primary/30 bg-primary/20 text-primary font-semibold",
        topContributor:
          "border-yellow-500/30 bg-yellow-900/30 text-yellow-400",
        // Project phase variants
        ideation:
          "border-amber-500/30 bg-amber-900/30 text-amber-400",
        development:
          "border-blue-500/30 bg-blue-900/30 text-blue-400",
        presentation:
          "border-purple-500/30 bg-purple-900/30 text-purple-400",
        delivered:
          "border-green-500/30 bg-green-900/30 text-green-400",
        archived:
          "border-gray-500/30 bg-gray-800/50 text-gray-400",
        // Activity type variants for Global Discourse
        dev:
          "border-blue-500/50 bg-blue-950 text-blue-400 font-mono text-[10px]",
        idea:
          "border-amber-500/50 bg-amber-950 text-amber-400 font-mono text-[10px]",
        vote:
          "border-purple-500/50 bg-purple-950 text-purple-400 font-mono text-[10px]",
        fund:
          "border-red-500/50 bg-red-950 text-red-400 font-mono text-[10px]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
